export default __webpack_public_path__ + "static/Native-touch-target-1.6-Do-9bf97061e561b47f8555c8a79869b8ca.png";